import { create } from 'zustand';
import {
  INITIAL_TERMINAL_SESSION,
  terminalSessionReducer,
  type TerminalSessionAction,
  type TerminalSessionState,
} from './pro-builder-terminal-session';

/**
 * FRONT-3003: the Pro Builder terminal's session state (`terminalKey`,
 * `startedWith`, `restartPending`) as one store, so the window — which mounts
 * the terminal and keys it by `terminalKey` — and Settings — which offers the
 * restart — read and write the same source. The pure transitions stay in
 * `pro-builder-terminal-session.ts`.
 */
interface ProBuilderSessionStore {
  session: TerminalSessionState;
  dispatch: (action: TerminalSessionAction) => void;
}

export const useProBuilderSessionStore = create<ProBuilderSessionStore>((set) => ({
  session: INITIAL_TERMINAL_SESSION,
  dispatch: (action) => set((s) => ({ session: terminalSessionReducer(s.session, action) })),
}));
